module.exports = __webpack_public_path__ + "static/img/logo02.d3a4f678.png";